// extracted by mini-css-extract-plugin
export default {"popupContainer":"popupContainer_popupContainer__xyERU","popupContainerRevert":"popupContainer_popupContainerRevert__t4a1-","closeIcon":"popupContainer_closeIcon__sigrf"};